import { numberFormat } from "../../../../../themes/custom/ev_theme/frontend/js/common/constants/variables/globalVariables";
import { loadMarker, getMapInstance } from "../../../../../themes/custom/ev_theme/frontend/js/components/loadMap";
let openMapValue = false;
let idMap = [];
let valuesMap = [];
let labelsMap = [];
// Función para cargar el mapa
export async function loadMap(filter) {
    const datosMap = await fetch(`/results-api/map${filter}&range=100`);
    const datosMapSend = await datosMap.json();
    // foreach marker maps
    if (datosMapSend.Items) {
        getCardMap(datosMapSend);
    }
}
// Función para manejar los elementos del mapa
export function getCardMap(datosMapSet, loadMapValue = false) {
    valuesMap = [];
    labelsMap = [];
    datosMapSet.Items.forEach((element) => {
        if (element.field_lat !== null && element.field_lon !== null) {
            let images = ``;
            element.field_images.forEach((image) => {
                images += `
                <li class="splide__slide">
                    <a href="${element.field_url[0]}">
                        <img loading="lazy" src="${image}" alt="Imagen ${element.field_name}">
                    </a>
                </li>`;
            });
            let pin = { lat: element.field_lat, lng: element.field_lon };
            valuesMap.push(pin);
            let label = `
            <div class="card-map">
                <a href="${element.field_url[0]}" id="link-form" class="link bold under">
                    Ir al proyecto <img alt="Flecha a la derecha"
                    src="/themes/custom/ev_theme/assets/images/fontawesome/arrow-right-long-solid-white.svg">
                </a>
                <div class="card-map__images">
                    <div class="splide splide__1 map__slider" id="splide-map-${element.field_node_id[0]}">
                        <div class="splide__track">
                            <ul class="splide__list">
                                ${images}
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="card-project__features maps">
                    <div class="card-project__features-item maps ev-tooltip area-simulation">
                        <div class="ev-tooltip__container">
                            <img src="/themes/custom/ev_theme/assets/images/iconos_resultados_cards/area-icon.png"
                                class="card-project__features-item-icon maps" alt="Área construida">
                            <p class="card-project__features-item-value maps">${element.field_typology_area_build[0]} m<sup>2</sup></p>
                            <span class="ev-tooltip__label"><b>?</b></span>
                            <div class="ev-tooltip__info"> El valor corresponde al área construida </div>
                        </div>
                    </div>`;
            if (element.field_alcobas[0]) {
                label += `
                        <div class="card-project__features-item maps">
                            <img src="/themes/custom/ev_theme/assets/images/iconos_resultados_cards/bedroom-icon.png"
                                class="card-project__features-item-icon maps" alt="Logo Alcobas">
                            <p class="card-project__features-item-value maps">${element.field_alcobas[0]}</p>
                        </div>`;
            }
            if (element.field_banos[0]) {
                label += `
                        <div class="card-project__features-item maps">
                            <img src="/themes/custom/ev_theme/assets/images/iconos_resultados_cards/bathroom-icon.png"
                                class="card-project__features-item-icon maps" alt="Logo Baños">
                            <p class="card-project__features-item-value maps">${element.field_banos[0]}</p>
                        </div>`;
            }
            if (element.field_garajes[0]) {
                label += `
                        <div class="card-project__features-item maps">
                            <img src="/themes/custom/ev_theme/assets/images/iconos_resultados_cards/parking-icon.png"
                                class="card-project__features-item-icon maps parking" alt="Logo Garaje">
                            <p class="card-project__features-item-value maps">${element.field_garajes[0]}</p>
                        </div>`;
            }
            label += `
                </div>
                <div class="card-map__info">
                    <a href="${element.field_url[0]}" class="card-map__info-title maps">
                        ${element.field_name}
                    </a>
                    <p class="card-map__info-price">
                        Desde:
                        <b class="card-map__info-price-value">
                             $${numberFormat(element.field_typology_price[0])}
                        </b>
                    </p>
                </div>
            </div>`;
            labelsMap.push(label);
            idMap.push(element.field_node_id[0]);
        }
    });
    if (openMapValue || loadMapValue) {
        loadMarker(valuesMap, labelsMap, idMap);
    }
}
function toggleContentMap(isOpen) {
    var _a, _b, _c, _d;
    const contentMap = document.getElementById('container-map');
    const contentMapBuilder = document.getElementById('content-map-section-builder');
    contentMap === null || contentMap === void 0 ? void 0 : contentMap.classList.toggle('open-map', isOpen);
    contentMapBuilder === null || contentMapBuilder === void 0 ? void 0 : contentMapBuilder.classList.toggle('open-map', isOpen);
    (_a = document.getElementById('results-without-map')) === null || _a === void 0 ? void 0 : _a.classList.toggle('d-none', isOpen);
    (_b = document.getElementById('content-map-section-builder')) === null || _b === void 0 ? void 0 : _b.classList.toggle('d-none', !isOpen);
    (_c = document.getElementById('content-card-builder')) === null || _c === void 0 ? void 0 : _c.classList.toggle('d-none', isOpen);
    Array.from(((_d = document.getElementById('content-projects')) === null || _d === void 0 ? void 0 : _d.children) || []).forEach(child => {
        child.classList.toggle('d-none', child.id == 'container-map' || child.id == '' ? !isOpen : isOpen);
    });
    document.querySelectorAll('.js-map').forEach(button => {
        button.innerHTML = isOpen ? 'Lista' : 'Mapa';
    });
    const mapInstance = getMapInstance();
    if (!mapInstance || !(mapInstance instanceof google.maps.Map))
        return;
    openMapValue = isOpen;
    if (isOpen) {
        setTimeout(() => {
            const mapInstance = getMapInstance();
            if (!mapInstance)
                return;
            google.maps.event.trigger(mapInstance, 'resize');
            mapInstance.setCenter({ lat: 6.9169505, lng: -73.707737 });
            loadMarker(valuesMap, labelsMap, idMap);
        }, 300);
    }
}
export function openMap() {
    const mapToggle = document.getElementById('map-toggle');
    if (mapToggle === null || mapToggle === void 0 ? void 0 : mapToggle.checked) {
        toggleContentMap(false);
    }
    else {
        toggleContentMap(true);
    }
}
export function closeMap() {
    toggleContentMap(false);
    const mapToggle = document.getElementById('map-toggle');
    mapToggle.checked = false;
}
